import { render, staticRenderFns } from "./activityCatalogue.vue?vue&type=template&id=24f67926&scoped=true"
import script from "./activityCatalogue.vue?vue&type=script&lang=js"
export * from "./activityCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f67926",
  null
  
)

export default component.exports